'use client'

import { useIntl } from 'react-intl'

import { MAX_BID_ROWS } from './deriveBidRows'
import {
  DashboardRowItem,
  DashboardRowList,
  SkeletonMetaLine,
  SkeletonTitleLine,
} from './ui'

const ns = 'Search.ordersBidsDashboard.bids'

/** Shaped like the real rows so the loaded list swaps in without a jump. */
export default function BidRowsSkeleton() {
  const intl = useIntl()

  return (
    <DashboardRowList
      aria-busy="true"
      aria-label={intl.formatMessage({ id: `${ns}.loading` })}
      data-testid="orders-bids-dashboard-bids-skeleton"
    >
      {Array.from({ length: MAX_BID_ROWS }, (_, i) => (
        <DashboardRowItem key={i} aria-hidden="true">
          <SkeletonTitleLine />
          <SkeletonMetaLine />
        </DashboardRowItem>
      ))}
    </DashboardRowList>
  )
}
